function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'heather-forest': 'rgb(74, 107, 104)','stone': 'rgb(216, 200, 187)','rust': 'rgb(187, 78, 49)','black': 'rgb(17, 17, 17)','heather-gray': 'rgb(50, 45, 46)','heather-clay': 'rgb(146, 68, 64)','navy': 'rgb(19, 34, 87)','blue': 'rgb(63, 112, 137)','dark-blue': 'rgb(12, 40, 54)','blue-rope': 'rgb(3, 87, 150)','green-rope': 'rgb(113, 204, 100)','orange-rope': 'rgb(243, 113, 24)','yellow-rope': 'rgb(248, 212, 54)','mauve': 'rgb(154, 76, 79)','deep-blue': 'rgb(41, 63, 131)','aqua': 'rgb(111, 184, 191)','teal': 'rgb(54, 97, 105)','lime': 'rgb(183, 201, 84)','green': 'rgb(115, 165, 131)','coral': 'rgb(233, 116, 99)','pale-green': 'rgb(185, 214, 158)','pale-yellow': 'rgb(238, 230, 207)','grapefruit': 'rgb(249, 188, 160)','seafoam-green': 'rgb(171, 209, 194)','baby-blue': 'rgb(201, 244, 247)','white-aqua': 'rgb(180, 197, 191)','white-green': 'rgb(3, 131, 36)','blue-cork': 'rgb(68, 112, 118)','brown-cork': 'rgb(72, 43, 37)','seafoam-cork': 'rgb(177, 197, 159)','black-cork': 'rgb(33, 26, 34)','ocean': 'rgb(18, 76, 153)','burgundy-cork': 'rgb(97, 20, 39)','navy-cork': 'rgb(40, 56, 90)','tan-cork': 'rgb(222, 186, 150)','white-cork': 'rgb(248, 245, 244)','yellow': 'rgb(255, 220, 0)','orange': 'rgb(255, 133, 27)','red': 'rgb(255, 65, 54)','teal-moby': 'rgb(72, 109, 119)','lime-moby': 'rgb(207, 225, 119)','blue-moby': 'rgb(93, 128, 183)','aqua-moby': 'rgb(162, 231, 222)','orchid': 'rgb(240, 18, 190)','bright-teal': 'rgb(0, 110, 143)','purple': 'rgb(177, 13, 201)','maroon': 'rgb(133, 20, 75)','silver': 'rgb(221, 221, 221)','gray': 'rgb(170, 170, 170)','white': 'rgb(255, 255, 255)','frosted-white': 'rgb(255, 255, 255)','emerald': 'rgb(32, 71, 9)','periwinkle': 'rgb(88, 122, 184)','sapphire': 'rgb(3, 34, 141)','pink': 'rgb(233, 186, 185)','pink-long': 'rgb(231, 195, 205)','brown': 'rgb(66, 49, 41)','mint': 'rgb(170, 255, 195)','pacific': 'rgb(39, 113, 209)','lavender': 'rgb(230, 190, 255)','blue-second-entry': 'rgb(28, 74, 236)','tan': 'rgb(160, 78, 59)','burnt-orange': 'rgb(100, 47, 13)','cognac': 'rgb(118, 24, 14)','indigo': 'rgb(45, 46, 51)','military': 'rgb(118, 105, 82)','charcoal': 'rgb(101, 97, 104)','french': 'rgb(103, 109, 141)','natural-wood': 'rgb(238, 215, 171)','grotto': 'rgb(12, 114, 110)','vintage-mustard': 'rgb(223, 159, 70)','spanish-moss': 'rgb(98, 106, 62)','sage': 'rgb(150, 170, 171)','peach': 'rgb(229, 203, 189)','moss': 'rgb(87, 94, 50)','clay': 'rgb(146, 60, 41)','heathered-forest': 'rgb(60, 76, 74)','heathered-navy': 'rgb(47, 55, 82)','burgundy': 'rgb(110, 25, 32)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
